export const NAVIGATION_TABS = {
  POPULARITY_ICON_SIZE: 12,
  DESCRIPTION_TOOLTIP_WIDTH: 288,
  CONTAINER_OFFSET: {
    desktop: 0,
    mobile: 40
  },

  ACTION_TYPES: {
    tabClick: 'tabClick'
  },

  DIRECTIONS: {
    prev: 'prev',
    next: 'next'
  },

  TAB: {
    INDEX: {
      COMPETITION: {
        custom: -1,
        details: 0,
        standings: 1,
        brackets: 2,
        stats: 3,
        insights: 4,
        odds: 5,
        transfers: 6,
        matches: 7,
        news: 8,
        highlights: 9,
        history: 10
      },

      NEW_COMPETITION: {
        custom: -1,
        index: 0,
        standings: 1,
        brackets: 2,
        stats: 3,
        insights: 4,
        odds: 5,
        transfers: 6,
        matches: 7,
        news: 8,
        highlights: 9,
        history: 10,
        medals: 11
      },

      COMPETITOR: {
        custom: -1,
        details: 0,
        standings: 1,
        brackets: 2,
        stats: 3,
        squad: 4,
        transfers: 5,
        matches: 6,
        news: 7,
        highlights: 8
      },

      GAME_CENTER: {
        custom: -1,
        match: 0,
        lineups: 1,
        stats: 2,
        trends: 3,
        odds: 4,
        propositionBets: 5,
        h2h: 6,
        news: 7,
        pointByPoint: 8
      },

      MATCHES: {
        recent: 0 ,
        fixtures: 1,
        results: 2
      }
    }
  }
}

